import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AssessmentDto, EditProtectiveMeasure } from '../../model/assessment.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslocoDirective } from '@jsverse/transloco';
import { ProtectiveMeasureItemComponent } from '../protective-measure-item/protective-measure-item.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-protective-measures-list',
  template: `
    <div
      *transloco="let t; read: 'building.assessment.protectiveMeasuresForm'"
      [class.read-only]="readOnly"
      data-testid="sibat-protective-measures-list"
      class="container gap-between-items"
    >
      @if (listProtectiveMeasures?.length > 0) {
      <h4>{{ t('listeMeasures') }}</h4>
      }
      <div class="gap-between-items">
        @for (measure of listProtectiveMeasures; track measure) {
        <sibat-protective-measure-item
          [buildingId]="buildingId"
          [assessment]="assessment"
          [readOnly]="readOnly"
          [offline]="offline"
          [displayTooltip]="(isMobileOrTabletScreen$ | async) === false"
          [measure]="measure"
          (measureSaved)="updateMeasure($event)"
        ></sibat-protective-measure-item>
        }
      </div>
      <!-- TODO protective-measure-list-offline as defects-list-offline-->
    </div>
  `,
  styleUrls: ['protective-measures-list-component.scss'],
  imports: [TranslocoDirective, ProtectiveMeasureItemComponent, AsyncPipe],
})
export class ProtectiveMeasuresListComponent implements OnInit, OnChanges {
  @Input() readOnly: boolean;
  @Input() buildingId: number | undefined;
  @Input() assessment: AssessmentDto;
  @Input() offline: boolean;
  @Output() measureSaved = new EventEmitter<EditProtectiveMeasure>();

  isMobileOrTabletScreen$: Observable<boolean>;
  listProtectiveMeasures: EditProtectiveMeasure[];

  constructor(private store: Store, private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.isMobileOrTabletScreen$ = this.breakpointObserver.observe('(max-width: 959px)').pipe(map(state => state.matches));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.assessment) {
      const assessment = changes.assessment.currentValue;
      if (assessment && assessment.protectiveMeasures) {
        this.listProtectiveMeasures = [...this.assessment.protectiveMeasures];
      }
    }
  }

  updateMeasure(measure: EditProtectiveMeasure): void {
    this.measureSaved.emit(measure);
  }
}
